<template>
  <div>
    <div class="row">
      <div class="col-md-4 col-sm-6 col-xs-6">
        <base-button
          :disabled="everythingShouldBeDisabled"
          @click="exportToExcel()"
          class="btn-dark float-sm-none float-md-left more-margin-top"
          >Excel</base-button
        >
      </div>

      <!-- Show Search Page "Search Order" Styling -->
      <!-- <div class="col-md-3 offset-md-5">
        <label for="searchBox">Search:</label>
        <el-input
          id="searchBox"
          :disabled="everythingShouldBeDisabled"
          type="search"
          class="mb-3 search-input"
          clearable
          prefix-icon="el-icon-search"
          placeholder="Search all Orders..."
          v-model="searchText"
          v-b-popover.hover.left="
            'Search results appear immediately upon typing.'
          "
        ></el-input>
      </div> -->
    </div>
    <div class="row">
      <el-table
        :data="getResults"
        :cell-style="tableRowClassName"
        :default-sort="{ prop: 'orderId', order: 'descending' }"
        aria-label="Order search results table"
      >
        <el-table-column :min-width="110" align="left" label="Actions">
          <template slot-scope="props">
            <router-link
              :to="`/order/view/${props.row.orderId}`"
              class="btn-link link-dark"
              :aria-label="`View Order No ${props.row.orderId}`"
            >
              <i class="tim-icons icon-zoom-split"></i>
              <span class="hide-if-small-screensize">View</span>
            </router-link>
            <br
              v-if="userIsAssigned(props.row) && (props.row.orderStatus !== 'COMPLETED' && props.row.orderStatus !== 'CANCELLED')"
            />
            <router-link
              v-if="userIsAssigned(props.row) && (props.row.orderStatus !== 'COMPLETED' && props.row.orderStatus !== 'CANCELLED')"
              class="btn-link btn-primary"
              :to="'/order/edit/' + props.row.orderId"
              :aria-label="`Edit Order No ${props.row.orderId}`"
            >
              <i class="tim-icons icon-pencil"></i>
              <span class="hide-if-small-screensize">Edit</span>
            </router-link>
            <br />
            <a
              href="##"
              @click="clickShowDetailsModal(props.row.orderId)"
              class="btn-link btn-warning"
              :aria-label="`More details for order no ${props.row.orderId}`"
            >
              <i class="tim-icons icon-notes"></i>
              <span class="hide-if-small-screensize">More</span>
            </a>
          </template>
        </el-table-column>
         

        <el-table-column
          v-for="column in tableColumns"
          sortable
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
        ></el-table-column>

         <el-table-column
          sortable
          prop="assignedLogisticsUser"
          label="Logistics"
          minWidth="180"
        >
          <template  slot-scope="order">
                     <i v-if="(order.row.logisticsUser ? order.row.logisticsUser.approvalStatusId == lockedStatusId : false)" class="tim-icons icon-lock-circle"></i>
          <span style="background: none;"> {{ order.row.assignedLogisticsUser }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="assignedFinanceUser"
          label="Finance"
          minWidth="180"
        >
          <template  slot-scope="order">
          <i v-if="(order.row.financeUser ? order.row.financeUser.approvalStatusId == lockedStatusId : false)" class="tim-icons icon-lock-circle"></i>
          <span style="background: none;"> {{ order.row.assignedFinanceUser }}</span>
          </template>
        </el-table-column>

        <el-table-column
          sortable
          prop="overdueForecast"
          label="Overdue / Delinquent"
          minWidth="250"
        >
          <template slot-scope="order">
            <span v-html="order.row.overdueForecast"></span>
          </template>
        </el-table-column>
      </el-table>
      <b-modal
        ref="showDetailsModal"
        scrollable
        hide-footer
        hide-header
        no-close-on-backdrop
        size="lg"
        body-class="custom_alert_body"
      >
        <div class="alert_header align-center">
          <br />
          Additional Information for Order ID: {{ this.selectedOrderId }}
        </div>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <label for="organization">Organization:</label>
              <base-input
                id="organization"
                disabled
                v-model="this.organization"
              ></base-input>

              <label for="agreedReturnDate">Agreed Return Date:</label>
              <base-input
                id="agreedReturnDate"
                disabled
                v-model="this.agreedReturnDateLabel"
              ></base-input>
            </div>
            <div class="col-sm-6">
              <label for="deliveryStartDate">Delivery Start Date</label>
              <base-input
                id="agreedReturnDate"
                disabled
                v-model="this.deliveryStartDateLabel"
              ></base-input>
            </div>
            <div class="col-sm-6">
              <label for="deliveryEndDate">Delivery End Date</label>
              <base-input
                id="agreedReturnDate"
                disabled
                v-model="this.deliveryEndDateLabel"
              ></base-input>
            </div>
          </div>
        </div>

        <div class="alert_footer align-center">
          <base-button
            type="primary"
            @click="clickCloseModal()"
            class="btn-primary"
          >
            <i class="tim-icons icon-double-left"></i> Return to Table
          </base-button>
        </div>
      </b-modal>
    </div>

    <div class="row justify-content-end">
      <label for="ResultsPerPageDropdown" class="results-per-page"
        >Results Per Page:</label
      >
      <el-select
        :disabled="everythingShouldBeDisabled"
        id="ResultsPerPageDropdown"
        v-model="selectedResultsPerPage"
        readonly="false"
        name="PageOptions"
        class="select-primary"
      >
        <el-option
          v-for="(item, index) in getResultsPerPageOptions"
          :value="item"
          class="select-primary"
          :key="index"
        ></el-option>
      </el-select>

      <base-pagination
        :perPage="getTotalNumberOfPages"
        v-model="selectedPage"
        :pageCount="getTotalNumberOfPages"
      />
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import { Modal, BasePagination } from "@/components";
import { Table, TableColumn, Select, Option } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import Util from "@/util/util";
import LoadingAlertMixin from "@/mixins/docLoadingAlert";
import swal from "sweetalert2";
export default {
  mixins: [LoadingAlertMixin],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  name: "SearchShowAllOrders",
  data: function () {
    return {
      selectedOrderId: 0,
      lockedStatusId: 0,
      organization: "",
      agreedReturnDateLabel: "",
      deliveryStartDateLabel: "",
      deliveryEndDateLabel: "",
      tableColumns: [
        {
          prop: "orderId",
          label: "Order No.",
          minWidth: 140,
        },
        {
          prop: "requisitionNumber",
          label: "Requisition #",
          minWidth: 160,
        },
        {
          prop: "countryName",
          label: "Country",
          minWidth: 120,
        },
        {
          prop: "orderStatus",
          label: "Status",
          minWidth: 150,
        },
        {
          prop: "totalLabel",
          label: "Total",
          minWidth: 150,
        },
        {
          prop: "paymentMethod",
          label: "Method of Payment",
          minWidth: 200,
        },
        {
          prop: "usBuySell",
          label: "Buy/Sell",
          minWidth: 130,
        },
        
      ],
      excelLoadTime: 0,
      searchTimeOut: null,
      searchText: "",
      everythingShouldBeDisabled: true,
      selectedResultsPerPage: 10,
      selectedPage: 1,
    };
  },
  created() {
    this.lockedStatusId = Util.LOCKED;
  },
  watch: {
    searchText(value) {
      clearTimeout(this.searchTimeOut);

      var self = this;
      let tempSearchCriteria = this.searchCriteria;
      tempSearchCriteria.SearchText = value;
      self.setSearchCriteria(tempSearchCriteria);
      self.searchTimeOut = setTimeout(function () {
        self.getSearchResults();
      }, 1000);
    },
    selectedResultsPerPage(value) {
      let tempSearchCriteria = this.searchCriteria;
      tempSearchCriteria.PageNumber = 1;
      tempSearchCriteria.ResultsPerPage = value;
      this.search(tempSearchCriteria);
    },
    selectedPage(value) {
      let tempSearchCriteria = this.searchCriteria;
      tempSearchCriteria.PageNumber = value;
      this.search(tempSearchCriteria);
    },
  },
  computed: {
    ...mapGetters({
      searchCriteria: "orders/searchCriteria",
      searchResults: "orders/searchResults",
      user: "users/user",
    }),
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    getServerResults() {
      if (!Util.isNullOrEmpty(this.searchCriteria)) {
        return this.searchResults;
      } else {
        return [];
      }
    },
    getResultsPerPageOptions() {
      return Util.getInitialPaginationInfo().perPageOptions;
    },
    getCurrentPage() {
      return Util.isNullOrEmpty(this.getServerResults)
        ? 1
        : this.getServerResults.currentPage;
    },
    getResultsPerPage() {
      return Util.isNullOrEmpty(this.getServerResults)
        ? Util.getInitialPaginationInfo().perPage
        : this.getServerResults.pageSize;
    },
    getTotalNumberOfPages() {
      return Util.isNullOrEmpty(this.getServerResults)
        ? 1
        : this.getServerResults.pageCount;
    },
    getResults() {
      return Util.isNullOrEmpty(this.getServerResults)
        ? []
        : this.getServerResults.results;
    },
  },
  methods: {
    ...mapActions({
      getSearchResults: "orders/getSearchResults",
      setSearchCriteria: "orders/setSearchCriteria",
      getSearchExportResults: "orders/getSearchExportResults",
      getOrdersBySearchFieldsToExcel: "orders/getOrdersBySearchFieldsToExcel",
    }),
    enableEverything() {
      // This is called in Search.vue
      this.everythingShouldBeDisabled = false;
    },
    disableEverything() {
      // This is called in Search.vue
      this.searchText = "";
      this.everythingShouldBeDisabled = true;
    },
    handleNewSearch() {
      // This is called in Search.vue
      this.selectedPage = 1;
    },
    search(tempSearchCriteria) {
      this.setSearchCriteria(tempSearchCriteria);
      this.getSearchResults();
    },
    setExcelSearchCriteria() {
      let tempSearchCriteria = this.searchCriteria;
      tempSearchCriteria.IsExport = true;
      this.setSearchCriteria(tempSearchCriteria);
    },
    async exportToExcel() {
      this.excelLoadTime += 1;

      if (this.getServerResults.recordCount > 0) {
        this.setExcelSearchCriteria();
        this.getOrdersBySearchFieldsToExcel(this.searchCriteria).then(
          (result) => {
            this.excelLoadTime = 0;
            this.closeLoadingAlert();
          }
        ).catch((error) => {
          this.excelLoadTime = 0;
          this.closeLoadingAlert();
        });
      } else {
        data = [];
      }

      await new Promise((r) => setTimeout(r, 2000));
      if (this.excelLoadTime != 0) {
        this.showLoadingSweetAlert(
          "Your Excel document is loading.<br><br>This message will disappear automatically in 10 seconds."
        );
      }

      while (this.excelLoadTime != 0) {
        await new Promise((r) => setTimeout(r, 10000));
        if (this.excelLoadTime != 0) {
          this.updateLoadingMessage(
            'Please hang tight. Your Excel document is <i>still loading</i>.<br><br><b>Note: <br><li>Depending on how many orders you export, it could take anywhere from a few seconds to over 5 minutes.</li><br><br><li>For exporting a large amount of orders, please consider "Create Report" (under Reports dropdown in navbar).</li>'
          );
        }
      }
    },
    userIsAssigned(rowOrder) {
      if (
        !Util.isNullOrEmpty(rowOrder.logisticsUser) &&
        rowOrder.logisticsUser.id.toLowerCase() == this.user.id.toLowerCase()
      ) {
        return true;
      } else if (
        !Util.isNullOrEmpty(rowOrder.financeUser) &&
        rowOrder.financeUser.id.toLowerCase() == this.user.id.toLowerCase()
      ) {
        return true;
      } else {
        return false;
      }
    },
    tableRowClassName({ row, columnIndex }) {
      if (row.overdueForecast.includes("\!") && columnIndex === 10) {
        return {
          // It is column 10 for overdue/delinquent highlighting.
          background: "#ffcece",
        };
      }
    },
    getOrderById(orderIdFromHtml) {
      return this.getResults.find((order) => order.orderId === orderIdFromHtml);
    },
    clickShowDetailsModal(orderIdFromHtml) {
      this.selectedOrderId = orderIdFromHtml;
      this.organization = this.getOrderById(orderIdFromHtml).organization;
      this.agreedReturnDateLabel = this.getOrderById(
        orderIdFromHtml
      ).agreedReturnDateLabel;
      this.deliveryStartDateLabel = this.getOrderById(
        orderIdFromHtml
      ).deliveryStartDateLabel;
      this.deliveryEndDateLabel = this.getOrderById(
        orderIdFromHtml
      ).deliveryEndDateLabel;
      this.$refs.showDetailsModal.show();
    },
    clickCloseModal() {
      this.$refs.showDetailsModal.hide();
    },
  },
};
</script>

<style scoped>
.el-tooltip .btn-link .btn-warning .focusing {
  color: orange !important;
}

@media only screen and (max-width: 2038px) {
  .hide-if-large-screensize {
    display: none;
  }
}

@media only screen and (max-width: 800px) {
  .hide-if-medium-screensize {
    display: none;
  }
}
</style>